import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../../components/Table";
import { Label, Form, Button } from "reactstrap";
import InvestorCard from "../../../../components/InvestorCard/InvestorCard";
import PropertiesDetails from "../../../../components/Properties/PropertiesDetails";
import DocumentsCard from "../../../../components/DocumentsCard/DocumentsCard";
import axios from "axios";
import { environment } from "../../../../env";
import {
  getQueryAction,
  loaderAction,
} from "../../../../redux/actions/Index";
import { useForm } from "react-hook-form";
import EmptyDoc from "../../../../components/errorComponents/EmptyDoc";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { Users, MagnifyingGlass, User } from "@phosphor-icons/react";
import ErrorComponents from "../../../../components/errorComponents/ErrorComponents";
import { object } from "prop-types";
import TenantAgeingModal from "../../../../components/Modal/TenantAgeingModal";

const SearchInvestors = () => {
  const userProject = useSelector((state) => state?.ModalReducer?.userproject);
  const projectList = useSelector((state) => state?.ModalReducer?.projectList);
  const buildingList = useSelector(
    (state) => state?.ModalReducer?.buildingList
  );
  const galaList = useSelector((state) => state?.ModalReducer?.galaList);
  const soldGalas = useSelector((state) => state?.ModalReducer?.soldGalaList);

  const [investor, setInvestor] = useState([]);
  const [investordetails, setInvestorDetails] = useState();
  const [investorproperties, setInvestorProperties] = useState();
  const [seltenant, setSeltenant] = useState();
  const [showProperties, setShowProperties] = useState(false);
  const [propertiesDetail, setPropertiesDetail] = useState();
  const [prevtenant, setPreTenant] = useState([]);
  const [filterBuilding, setFilterBuilding] = useState([]);
  const [GalaFilters, setGalaFilters] = useState([]);
  const [GalaFil, setGalaFil] = useState([]);
  const [SubGalaFil, setSubGalaFil] = useState([]);
  const [documentDetails, setDocumentDetails] = useState();
  const [update, setUpdate] = useState(false);
  const [invToggle, setInvToggle] = useState(false);
  const apiTimeOut = useRef(null);
  const dispatch = useDispatch();

  const soldGalaList = soldGalas?.filter(
    (item) => item.resell_area <= item.sold_gala_area
  );
  const ref = useRef(null);
  if (SubGalaFil) {
    var subGalaFilter = Array.from(
      new Set(
        SubGalaFil.map((item) => item.sub_gala_name).sort((a, b) => a - b)
      )
    );
  }

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    reset: reset2,
    formState: { errors: errors2 },
  } = useForm();

  const {
    register: register3,
    watch: watch3,
    reset: reset3,
    setValue: setValue3,
  } = useForm();

  var selectedBuildingId3 = watch3("building");
  var selectedProjectName3 = watch3("project");
  var selectedGala3 = watch3("gala_no");
  var selectedsGala3 = watch3("sub_gala_no");
  var selname = watch3("search");
  selname = selname == undefined ? "" : selname

  useMemo(() => {
    setInvToggle(false);
    setInvestorDetails();
    setInvestorProperties();
    if (
      selname ||
      selectedProjectName3 ||
      selectedBuildingId3 ||
      selectedGala3 ||
      selectedsGala3
    ) {
      if (selname == undefined) {
        setValue3("search", "");
      }
      if (selectedProjectName3 == undefined) {
        projectList?.map((data, i) => {
          if (data.id == userProject) {
            selectedProjectName3 = data.name;
          }
        });
      }
      if (selectedsGala3 == undefined) {
        setValue3("sub_gala_no", "");
      }
      const SearchUrl = `${environment.baseUrl}sold-gala-filter/?gala=${selectedGala3}&building=${selectedBuildingId3}&project=${selectedProjectName3}&investor=${selname}&subgala=${selectedsGala3}`;
      if (!(selectedGala3 == "" && selectedBuildingId3 == "" && selname == "" && selectedsGala3 == "")) {
        axios(SearchUrl).then((res) => {
          if (
            selname == "" &&
            selectedBuildingId3 == "" &&
            selectedGala3 == "" &&
            selectedsGala3 == ""
          ) {
            setInvestor([]);
            return;
          }
          if (res?.data?.length > 0) {
            setInvestor(res.data);
            setInvToggle(true);
            dispatch(loaderAction(false));
          } else {
            setInvestor([]);
            dispatch(loaderAction(false));
          }
        });
      }
    }

  }, [
    selectedBuildingId3,
    selectedGala3,
    selectedsGala3,
  ]);

  useMemo(() => {
    if (apiTimeOut.current) {
      clearTimeout(apiTimeOut.current);
    }

    apiTimeOut.current = setTimeout(() => {

      setInvToggle(false);
      setInvestorDetails();
      setInvestorProperties();
      if (
        selname ||
        selectedProjectName3 ||
        selectedBuildingId3 ||
        selectedGala3 ||
        selectedsGala3
      ) {
        if (selname == undefined) {
          setValue3("search", "");
        }
        if (selectedProjectName3 == undefined) {
          projectList?.map((data, i) => {
            if (data.id == userProject) {
              selectedProjectName3 = data.name;
            }
          });
        }
        if (selectedsGala3 == undefined) {
          setValue3("sub_gala_no", "");
        }
        const SearchUrl = `${environment.baseUrl}sold-gala-filter/?gala=${selectedGala3}&building=${selectedBuildingId3}&project=${selectedProjectName3}&investor=${selname}&subgala=${selectedsGala3}`;
        if (!(selectedGala3 == "" && selectedBuildingId3 == "" && selname == "" && selectedsGala3 == "")) {
          axios(SearchUrl).then((res) => {
            if (
              selname == "" &&
              selectedBuildingId3 == "" &&
              selectedGala3 == "" &&
              selectedsGala3 == ""
            ) {
              setInvestor([]);
              return;
            }
            if (res?.data?.length > 0) {
              setInvestor(res.data);
              setInvToggle(true);
              dispatch(loaderAction(false));
            } else {
              setInvestor([]);
              dispatch(loaderAction(false));
            }
          });
        }
      }
      apiTimeOut.current = null;
    }, 2000)

  }, [selname]);

  useEffect(() => {
    return () => {
      if (apiTimeOut.current) {
        clearTimeout(apiTimeOut)
      }
    }
  })

  useMemo(() => {
    if (selectedProjectName3 && selectedProjectName3 !== "") {
      {
        var projectBuilding = buildingList?.filter(
          (filterBuilding) =>
            filterBuilding.project.name == selectedProjectName3
        );
        setFilterBuilding(projectBuilding);
      }
    } else {
      setInvestor([]);
    }
    if (selectedBuildingId3) {
      var galaselected = soldGalaList?.filter(
        (galalist) => galalist.building.building_no == selectedBuildingId3
      );
      var galaselectedd = galaList?.filter(
        (galalist) => galalist.building.building_no == selectedBuildingId3
      );
      setGalaFil(galaselectedd);
      setSubGalaFil([]);
    }
    if (selectedGala3) {
      var galaselected = soldGalaList?.filter(
        (galalist) =>
          String(galalist?.gala?.gala_no) === String(selectedGala3) &&
          galalist.building.building_no == selectedBuildingId3
      );
      setSubGalaFil(galaselected);
    }
    if (selectedsGala3) {
      var galaselected = soldGalaList?.filter(
        (galalist) =>
          galalist?.sub_gala_name == selectedsGala3 &&
          galalist?.gala?.gala_no == selectedGala3 &&
          galalist.building.building_no == selectedBuildingId3
      );
      if (galaselected.length == 0) {
        toast.warn("Data Not Found !", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
        });
      }
    }
  }, [
    selectedProjectName3,
    selectedBuildingId3,
    selectedGala3,
    selectedsGala3,
    selname,
  ]);

  useEffect(() => {
    projectList?.map((data, i) => {
      if (data.id == userProject) {
        setValue3("project", data.name);
      }
    });
    getInvestorProperties();
  }, [update, userProject]);

  const ordinal = (i) => {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  };
  const columns = [
    {
      name: "Party Name",
      selector: (row) => row.Investors?.name,
      wrap: true,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Contact",
      selector: (row) => row.Investors?.contact_number,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Status",
      selector: (row) => (
        <div className="d-flex justify-content-between align-items-center gap-2 ">
          <label
            className={`${row.ownership === 1 && "icon-bg-green icon-color-green "
              } ${row.ownership === 2 && "icon-bg-yellow icon-color-yellow"} ${row.ownership == 3 && "status-bg-blue status-color-blue"
              } ${row.ownership >= 4 && "bg-info text-white"
              }   rounded-pill status-box rounded fs-4`}
          >{`${ordinal(row.ownership)} Owner`}</label>
        </div>
      ),
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Owner Type",
      selector: (row) => (
        <div className="d-flex justify-content-between align-items-center gap-3 ">
          <span>
            {row?.ownertype == "Self" ? (
              <User size="26" className="text-base-red" />
            ) : (
              row?.ownertype == "Joined" && (
                <Users size="26" className="status-color-blue" />
              )
            )}
          </span>
          <label className="fs-3">{row?.ownertype}</label>
        </div>
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Building No",
      selector: (row) => row.building?.building_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },

    {
      name: "Gala No",
      selector: (row) => Number(row.gala?.gala_no),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Sub Gala",
      selector: (row) => row.sub_gala_name,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Area",
      selector: (row) => row.sold_gala_area - row.resell_area + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Sell Date",
      selector: (row) => moment(row.created_at).format("DD/MM/YYYY"),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
  ];

  const columnns = [
    {
      name: "Building No",
      selector: (row) => row.building?.building_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Gala No",
      selector: (row) => Number(row.gala?.gala_no),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Sub Gala",
      selector: (row) => row.sub_gala_name,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Area Owns",
      selector: (row) => row.sold_gala_area + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Rented Area",
      selector: (row) => row.rent_area + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Balance Area",
      selector: (row) => row.sold_gala_area - row.rent_area + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
  ];

  const cols = [
    {
      name: "Building No",
      selector: (row) => row?.building_no?.building_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Gala No.",
      selector: (row) => {
        let d = row.piproposal.filter((item) => {
          return item?.investor?.gala?.id == propertiesDetail?.gala?.id;
        });
        return d[0]?.investor?.gala?.gala_no;
      },
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Tenant Name",
      selector: (row) => row.name_of_company,
      wrap: true,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Aggreement Start",
      selector: (row) =>
        moment(row?.gtproposal[0]?.aggrement_start_date).format("DD/MM/YYYY"),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Aggreement End",
      selector: (row) =>
        moment(row?.gtproposal[0]?.aggrement_end_date).format("DD/MM/YYYY"),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
  ];

  const getInvestorProperties = (selected) => {
    if (selected != undefined) {
      dispatch(loaderAction());
      axios
        .get(`${environment.baseUrl}investor-properties/${selected}`)
        .then((res) => {
          let total = 0;
          res.data.map((data) => (total = total + Number(data.sold_gala_area)));
          res.data.total = total;
          setInvestorProperties(res.data);
          setPropertiesDetail([])
          dispatch(loaderAction());
          setShowProperties(false);
          setDocumentDetails([]);
        })
        .catch((res) => {
          dispatch(loaderAction());
          console.log("error");
        });
    }
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const selectedProject = (selected) => {
    dispatch(loaderAction());
    axios
      .get(`${environment.baseUrl}editinvestor/${selected}`)
      .then((res) => {
        setInvestorDetails(res.data);
        setInvToggle(false);
        dispatch(loaderAction());
      })
      .catch((res) => {
        dispatch(loaderAction());
      });
  };

  const Clear = () => {
    setInvestor([]);
    setInvToggle(false);
    setInvestorDetails();
    setInvestorProperties();
    reset3({
      search: "",
      building: "",
      gala_no: "",
      sub_gala_no: "",
    });
    projectList?.map((data, i) => {
      if (data.id == userProject) {
        setValue3("project", data.name);
      }
    });
    if (
      selectedBuildingId3.length != 0 ||
      selectedGala3.length != 0 ||
      selectedsGala3 != 0
    ) {
      toast.success("Filter Clear Successfully !", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
      });
    }
  };

  const CurrentTenants = () => {
    const payload = {
      gala: propertiesDetail?.gala?.id,
      sub_gala: propertiesDetail?.sub_gala_name,
    };
    if (!(payload.gala == undefined && payload.sub_gala == undefined)) {
      const SearchUrl = `${environment.baseUrl}current-tenant`;
      const result = axios.post(SearchUrl, payload).then((res) => {
        if (res?.data?.length > 0) {
          let arr = [];
          res.data.map((data) => {
            if (data?.gtproposal?.length != 0) {
              arr.push(data);
            }
          });
          setPreTenant(arr);
        } else {
          setPreTenant([]);
        }
      });
    }
  };

  const getQueryData = () => {
    try {
      axios
        .get(`${environment.baseUrl}query`)
        .then((res) => {
          let data = res.data;
          dispatch(getQueryAction(data));
        })
        .catch((res) => {
          console.log("error");
        });
    } catch (err) {
      console.log(err);
    }
  };

  const CreateQuery = (data) => {
    if (propertiesDetail?.id == undefined) {
      toast.error("Please Select the Property First!", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    data.gala_investor = propertiesDetail?.id;
    const QueryUrl = `${environment.baseUrl}query`;
    const result = axios.post(QueryUrl, data).then((res) => {
      getQueryData();
      CancelQuery();
      toast.success("Query Submitted!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    });
  };

  const CancelQuery = () => {
    reset2({ comment: "" });
  };

  useMemo(() => {
    CurrentTenants();
  }, [propertiesDetail]);

  useEffect(() => {
    if (buildingList != undefined) {
      setFilterBuilding(buildingList);
    }
  }, [buildingList])

  return (
    <>
      <TenantAgeingModal />
      <div className="dashboard-main">
        <div className="dashboard-body">
          <Form>
            <div className="my-4 row">
              <div className="col-11 mx-auto mx-md-0 col-md-2 col-lg-3 col-xl-3 pb-3 pt-1">
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="search"
                    autoComplete="off"
                    placeholder="Search Party Name..."
                    {...register3("search")}
                  />
                </div>
              </div>
              {/* <div className='col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1'>
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="role_type"
                    name="role_type"
                    className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register3("project", { required: true, onChange: (e) => { reset3({ "building": "", "gala_no": "", "sub_gala_no": "", "project": e.target.value }) } })}
                  >
                    <option value="">Project Name</option>
                    {projectList?.map((data, i) => {
                      return <option value={data.name} key={i}>{data.name}</option>;
                    })}
                  </select>
                </div>
              </div> */}
              <div className="col-11 mx-auto mx-md-0 col-md-2 col-lg-3 col-xl-3 pb-2 pt-1">
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="role_type"
                    name="role_type"
                    className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register3("building", {
                      required: true,
                      onChange: (e) => {
                        reset3({
                          building: e.target.value,
                          gala_no: "",
                          sub_gala_no: "",
                        });
                      },
                    })}
                  >
                    <option value="">Building Number</option>
                    {filterBuilding
                      ?.sort((a, b) =>
                        a?.building_no?.localeCompare(b.building_no)
                      )
                      ?.map((data, i) => {
                        return (
                          <option value={data.building_no} key={i}>
                            {data.building_no}
                          </option>
                        );
                      })}
                  </select>
                </div>
                {/* {errors.village_name && <ErrorComponents error={'Village name is required *'} />} */}
                <br />
              </div>
              <div className="col-11 mx-auto mx-md-0 col-md-2 col-lg-3 col-xl-3 pb-3 pt-1">
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="role_type"
                    name="role_type"
                    className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register3("gala_no", {
                      required: true,
                      onChange: (e) => {
                        reset({ gala_no: e.target.value, sub_gala_no: "" });
                      },
                    })}
                  >
                    <option value="">Gala No</option>
                    {GalaFil?.sort((a, b) => (a?.gala_no || 0) - (b?.gala_no || 0))?.map((data, i) => {
                      return (
                        <option value={data?.gala_no} key={i}>
                          {data?.gala_no}
                        </option>
                      );
                    })}
                  </select>
                </div>
                {/* {errors.village_name && <ErrorComponents error={'Village name is required *'} />} */}
                <br />
              </div>
              <div className="col-11 mx-auto mx-md-0 col-md-2 col-lg-2 col-xl-2 pb-3 pt-1">
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="role_type"
                    name="role_type"
                    className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register3("sub_gala_no", { required: true })}
                  >
                    <option value="">Sub Gala Name</option>
                    {subGalaFilter
                      ?.sort((a, b) => a.localeCompare(b))
                      ?.map((data, i) => {
                        return (
                          <option value={data} key={i}>
                            {data}
                          </option>
                        );
                      })}
                  </select>
                </div>
                {/* {errors.village_name && <ErrorComponents error={'Village name is required *'} />} */}
                <br />
              </div>
              <div className="col-11 mx-auto mx-md-0 col-md-1 col-lg-1 col-xl-1 pb-3 pt-1">
                <button
                  onClick={Clear}
                  type="button"
                  className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5center buttons py-4 btn btn-secondary"
                >
                  <span className="fs-3 d-flex gap-3 title-font-600 ps-3 pe-2">
                    Clear
                  </span>
                </button>
              </div>
            </div>
          </Form>
          <br />
        </div>
        {invToggle && !investordetails && (
          <div className="bg-white p-5 rounded-5">
            <div>
              <h1 className="mb-5 title-font-bold ">INVESTOR DETAILS</h1>
              <Table
                columns={columns}
                data={investor}
                update={setUpdate}
                selectedProject={selectedProject}
                getInvestorProperties={getInvestorProperties}
              />
            </div>
          </div>
        )}

        <div className="row row-cols-1 row-cols-md-3 gx-4 gy-0 my-5">
          {investordetails && (
            <div className="col">
              <InvestorCard
                investorName={investordetails?.name}
                panNumber={investordetails?.pan_no}
                address={investordetails?.address}
                contact={investordetails?.contact_number}
                gst={investordetails?.gst}
                noOfProperties={investorproperties?.length}
                adharNumber={investordetails?.aadhar_no}
                email={investordetails?.email}
                image={investordetails?.image}
                area={`${investorproperties?.total} sq.ft`}
              />
            </div>
          )}
        </div>
        {investorproperties?.length > 0 && (
          <div className="bg-white p-5 d-flex gap-5 flex-column rounded-5 mb-5">
            <div className="d-flex justify-content-between align-items-center">
              <h1 className="title-font-bold ">PROPERTIES</h1>
            </div>
            {/* <GalaProperties
              investorproperties={investorproperties}
              documentDetails={(documentDetails) =>
                setDocumentDetails(documentDetails)
              }
              propertiesDetail={(propertiesDetail) => {
                setPropertiesDetail(propertiesDetail);
                setDues(!dues);
              }}
              showProperties={(showProperties) =>
                setShowProperties(showProperties)
              }
            /> */}
            <Table
              columns={columnns}
              data={investorproperties}
              inves={true}
              documentDetails={(documentDetails) =>
                setDocumentDetails(documentDetails)
              }
              propertiesDetail={setPropertiesDetail}
              query={CancelQuery}
              showProperties={(showProperties) =>
                setShowProperties(showProperties)
              }
            />
          </div>
        )}
        <div ref={ref}></div>
        {showProperties && investordetails && prevtenant?.length != 0 && (
          <>
            <div className="bg-white p-5 d-flex  flex-column rounded-5">
              {prevtenant?.length != 0 && (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-5">
                    <h1 className="title-font-bold ">Current Tenants</h1>
                  </div>
                  <Table
                    columns={cols}
                    data={prevtenant}
                    selTenant={setSeltenant}
                    ctent={true}
                  />
                </>
              )}
              {seltenant && (
                <PropertiesDetails
                  id={seltenant?.gtproposal[0]?.id}
                  name={propertiesDetail?.Investors?.name}
                  purchaseDate={propertiesDetail?.created_at}
                  propDate={propertiesDetail?.building?.date_of_completion}
                  buildingNumber={propertiesDetail?.building?.building_no}
                  gala={propertiesDetail?.gala?.gala_no}
                  subGala={propertiesDetail?.sub_gala_name}
                  area={propertiesDetail?.sold_gala_area}
                  agree_str={seltenant?.gtproposal[0]?.aggrement_start_date}
                  agree_end={seltenant?.gtproposal[0]?.aggrement_end_date}
                  percentage={propertiesDetail?.Investors?.name}
                  broker_name={seltenant?.gtproposal[0]?.broker_name}
                  currentTenant={seltenant?.name_of_company}
                  rentAmount={
                    Number(seltenant?.rent_price) +
                    Number(seltenant?.varai) +
                    Number(seltenant?.maintenance) +
                    Number(seltenant?.extra_amenities) +
                    Number(seltenant?.other_charges)
                  }
                  rentDate={seltenant?.gtproposal[0]?.rent_actual_start_date}
                  propertyArea={propertiesDetail?.Investors?.name}
                  purchaseFrom={propertiesDetail?.Investors?.name}
                  possession={seltenant?.gtproposal[0]?.possession_date}
                />
              )}
            </div>
          </>
        )}

        {documentDetails?.length > 0 && investordetails && (
          <div className="my-5">
            <Label className="fs-1 title-font-700 pb-4">DOCUMENTS</Label>
            {documentDetails.length == 0 ? (
              <EmptyDoc />
            ) : (
              <DocumentsCard documentDetails={documentDetails} />
            )}
          </div>
        )}

        {propertiesDetail && investordetails && (
          <div className="bg-white p-5 d-flex  flex-column rounded-5 my-5">
            <div className="my-2">
              <Label className="fs-1 title-font-700 pb-4">CREATE QUERY</Label>
              <Form onSubmit={handleSubmit2(CreateQuery)}>
                <div className="col-12 pb-2">
                  <div className="col-12 mx-auto mx-md-0  pb-3 pt-1">
                    <div className="mt-1  d-flex gap-3">
                      <textarea
                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                        placeholder="Enter  Comments..."
                        {...register2("comment", { required: true })}
                      ></textarea>
                    </div>
                    {errors2.comment && (
                      <ErrorComponents error={"Comments is required *"} />
                    )}
                    <br />
                  </div>
                </div>
                <div className="d-flex justify-content-end align-items-center px-4">
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <Button
                      type="button"
                      onClick={CancelQuery}
                      className="border-radius-7 p-3 d-flex align-items-center buttons-outline"
                    >
                      <span className="fs-4 d-flex gap-3 title-font-600 px-3">
                        Cancel
                      </span>
                    </Button>
                    <Button className="border-radius-7 p-3 d-flex align-items-center buttons">
                      <span className="fs-4 d-flex gap-3 title-font-600 px-3">
                        Submit
                      </span>
                    </Button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SearchInvestors;
